import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class DropdownAccordion extends Component {
  static propTypes = {
    collection: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })),
    title: PropTypes.string.isRequired,
    titleClass: PropTypes.string,
    expanded: PropTypes.bool,
    listClass: PropTypes.string,
    listItemClass: PropTypes.string,
  }

  static defaultProps = {
    collection: [],
    expanded: false,
    titleClass: '',
    listClass: '',
    listItemClass: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded,
    };
  }

  handleToggleExpanded= () => {
    this.setState({ expanded: !this.state.expanded });
  }

  renderCollectionItem(item) {
    return (
      <li key={item.key}>
        <a href={item.href} className={this.props.listItemClass}>
          {item.text}
        </a>
      </li>
    );
  }

  renderCollection() {
    return (
      this.props.collection.map(
        (item) => this.renderCollectionItem(item)
      )
    );
  }

  render() {
    return (
      <div>
        <div className={this.props.titleClass} onClick={() => this.handleToggleExpanded()}>
          {this.props.title}
          <i className={this.state.expanded ? 'Icon Icon-caret-up u-text-grey-light' : 'Icon Icon-caret-down u-text-grey-light'}></i>
        </div>
        { this.state.expanded && (
          <ul className={this.props.listClass}>
            { this.renderCollection() }
          </ul>
        ) }
      </div>
    );
  }
}
